module.exports = __webpack_public_path__ + "img/coinspopup-2.f7f88b5b.png";